import { render, staticRenderFns } from "./beprinceIDCard.vue?vue&type=template&id=311ea5ba&scoped=true&"
import script from "./beprinceIDCard.vue?vue&type=script&lang=js&"
export * from "./beprinceIDCard.vue?vue&type=script&lang=js&"
import style0 from "./beprinceIDCard.vue?vue&type=style&index=0&id=311ea5ba&lang=scss&scoped=true&"
import style1 from "./beprinceIDCard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311ea5ba",
  null
  
)

export default component.exports